import { queryClient } from '@/client/query';
import riskProcessingStatusRepository from '@/repositories/risk-processing-status.repository';
import { useMutation, useQuery } from '@tanstack/react-query';

export function useGetRiskProcessingStatus() {
  return useQuery({
    queryKey: ['risk-processing-status', 'get'],
    queryFn: riskProcessingStatusRepository.getRiskProcessingStatus,
  });
}

export function useTriggerRiskReprocessingMutation() {
  return useMutation({
    mutationFn: riskProcessingStatusRepository.triggerRiskReprocessing,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['risk-processing-status', 'get'] });
    },
  });
}

export function useTriggerPotentialRiskMutation() {
  return useMutation({
    mutationFn: riskProcessingStatusRepository.triggerPotentialRiskReprocessing,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['potential-risk-processing', 'trigger'] });
    },
  });
}
